<h1 mat-dialog-title>{{ data && data.title ? data.title : 'Confirmation' }}</h1>
<div mat-dialog-content>
  <div class='mat-dialog-body' [innerHTML]="data && data.content ? data.content : ''"></div>

  <mat-form-field *ngIf='data && data.prompt' appearance='outline' class='full-width'>
    <mat-label>{{ data.prompt.label }}</mat-label>
    <textarea matInput rows='3' [(ngModel)]='promptValue' [required]='!!data.prompt.required'></textarea>
    <mat-hint *ngIf='data.prompt.hint'>{{ data.prompt.hint }}</mat-hint>
  </mat-form-field>
</div>

<div class='row' mat-dialog-actions>
  <div class='column--3'><button mat-flat-button mat-dialog-close color='accent'>Cancel</button></div>
  <div class='column--9 align-right'>
    <button
      mat-flat-button
      [color]="data && data.btnColor ? data.btnColor : 'primary'"
      [disabled]='confirmDisabled'
      [mat-dialog-close]='result' cdkFocusInitial
    >{{ data && data.confirmBtnLabel ? data.confirmBtnLabel : 'Confirm' }}</button>
  </div>
</div>
